import store from './store.vue'

export default store
